import React, { useState, useEffect } from "react";
import { TbEdit, TbCheck } from "react-icons/tb";
import { RxCross1 } from "react-icons/rx";
import "./SettingsInput.css";

const EditableSettingsInput = ({
  label,
  type = "text",
  placeholder,
  value: initialValue,
  onSave,
  onChange: parentOnChange,
  name,
  required = false,
  icon: Icon,
  alwaysEditable = false,
}) => {
  const [value, setValue] = useState(initialValue);
  const [isEditing, setIsEditing] = useState(alwaysEditable ? true : false);

  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  const handleEditClick = () => {
    setIsEditing(true);
  };

  const handleSaveClick = () => {
    if (onSave) {
      onSave(value);
    }
    setIsEditing(false);
  };

  const handleCancelClick = () => {
    setValue(initialValue);
    setIsEditing(false);
  };

  const handleInputChange = (e) => {
    const newValue = e.target.value;
    setValue(newValue);
    if (alwaysEditable && parentOnChange) {
      parentOnChange(newValue);
    }
  };

  return (
    <div className="editable-settings-input-container">
      {label && <label className="editable-settings-label">{label}</label>}
      <div className="editable-settings-input-wrapper">
        {Icon && <Icon className="editable-settings-icon" size={19} />}
        <input
          type={type}
          placeholder={placeholder}
          value={value}
          onChange={handleInputChange}
          name={name}
          required={required}
          disabled={alwaysEditable ? false : !isEditing}
          className="editable-settings-input"
        />
        {!alwaysEditable && (
          <div className="editable-settings-input-icons">
            {!isEditing ? (
              <button onClick={handleEditClick} className="edit-btn">
                <TbEdit className="editable-settings-input-icon" size={20} />
              </button>
            ) : (
              <>
                <button onClick={handleSaveClick} className="save-btn">
                  <TbCheck className="editable-settings-input-icon" size={20} />
                </button>
                <button onClick={handleCancelClick} className="cancel-btn">
                  <RxCross1
                    size={20}
                    className="editable-settings-input-icon"
                  />
                </button>
              </>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default EditableSettingsInput;
